import { forwardRef } from 'react';
import { Button } from '@mui/material';
import { alpha, getContrastRatio } from '@mui/material/styles';

// Shared report-navigation actions, including tooltip triggers that need a DOM ref.
const ReportToolbarButton = forwardRef(function ReportToolbarButton({ sx, ...props }, ref) {
    return <Button ref={ref} {...props} variant="outlined" size="medium" color="primary" sx={[
        theme => {
            const primary = getContrastRatio(theme.palette.primary.main, theme.palette.background.paper) >= 4.5
                ? theme.palette.primary.main : theme.palette.text.primary;
            return {
                minHeight: 44, px: 1.5, borderRadius: 2, textTransform: 'none',
                fontWeight: 700, whiteSpace: 'nowrap', boxShadow: 'none',
                color: primary, borderColor: alpha(primary, 0.35), background: theme.palette.background.paper,
                '&:hover': { borderColor: primary, background: alpha(primary, 0.06), boxShadow: 'none' },
                '&.Mui-focusVisible': { outline: `2px solid ${primary}`, outlineOffset: 2 },
            };
        },
        ...(Array.isArray(sx) ? sx : [sx]),
    ]} />;
});

export default ReportToolbarButton;
